import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleService } from '@shared/services';
import { UrlSerializer, RouterModule } from '@angular/router';
import { LowerCaseUrlSerializer } from '@shared/utils';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApproveDialogComponent, CopyDataRendererComponent, CustomTooltipComponent, FileLookPopupComponent } from '@shared/components';
import { DeleteDialogComponent } from '@shared/components';
import { TranslateDialogComponent } from '@shared/components';
import { CustomFilterComponent } from '@shared/components';
import { DataTableComponent } from '@shared/components';
import { WikiComponent } from '@shared/components';
import { SelectLanguageComponent } from '@shared/components';
import { FormatCellPipe } from '@shared/pipes';
import { MenuService } from '@shared/services';
import { MaterialModule } from '@shared/material.module';
import { FileUploaderComponent } from '@shared/components';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { TextboxCellComponent } from './components/dynamic-edit/cells/textbox-cell/textbox-cell.component';
import { TextareaCellComponent } from './components/dynamic-edit/cells/textarea-cell/textarea-cell.component';
import { CheckboxCellComponent } from './components/dynamic-edit/cells/checkbox-cell/checkbox-cell.component';
import { SelectlistCellComponent } from './components/dynamic-edit/cells/selectlist-cell/selectlist-cell.component';
import { SelectlistSearchCellComponent } from './components/dynamic-edit/cells/selectlist-search-cell/selectlist-search-cell.component';
import { DatepickCellComponent } from './components/dynamic-edit/cells/datepick-cell/datepick-cell.component';
import { ColorpickerCellComponent } from './components/dynamic-edit/cells/colorpicker-cell/colorpicker-cell.component';
import { DndCellComponent } from './components/dynamic-edit/cells/dnd-cell/dnd-cell.component';
import { TranslatedCellComponent } from './components/dynamic-edit/cells/translated-cell/translated-cell.component';
import { CheckboxGroupCellComponent } from './components/dynamic-edit/cells/checkbox-group-cell/checkbox-group-cell.component';
import { DynamicCellFormComponent } from './components/dynamic-edit/dynamic-cell-form/dynamic-cell-form.component';
import { TransformDirective } from './components/dynamic-edit/transform/transform.directive';
import { EditDialogComponent } from './components/dialogs/edit-dialog/edit-dialog.component';
import { TransformFormGroupDirective } from './components/dynamic-edit/transform/transform-formgroup.directive';
import { FileCellComponent } from './components/dynamic-edit/cells/file-cell/file-cell.component';
import { TimeCellComponent } from './components/dynamic-edit/cells/time-cell/time-cell.component';
import { DynamicListComponent } from './components/dynamic-edit/cells/dynamic-list/dynamic-list.component';
import { FilterToolbarComponent, HomeRootComponent } from './base';
import { CheckboxListCellComponent } from './components/dynamic-edit/cells/checkbox-list-cell/checkbox-list-cell.component';
import { SelectlistControlCellComponent } from './components/dynamic-edit/cells/selectlist-control-cell/selectlist-control-cell.component';

@NgModule({
  declarations: [
    SelectLanguageComponent,
    ApproveDialogComponent,
    DeleteDialogComponent,
    TranslateDialogComponent,
    DataTableComponent,
    WikiComponent,
    CustomFilterComponent,
    FormatCellPipe,
    FileUploaderComponent,
    DynamicCellFormComponent,
    FileLookPopupComponent,
    TextboxCellComponent,
    TextareaCellComponent,
    CheckboxCellComponent,
    CheckboxGroupCellComponent,
    CheckboxListCellComponent,
    SelectlistCellComponent,
    SelectlistSearchCellComponent,
    SelectlistControlCellComponent,
    DatepickCellComponent,
    ColorpickerCellComponent,
    DndCellComponent,
    TranslatedCellComponent,
    FileCellComponent,
    TimeCellComponent,
    DynamicListComponent,
    TransformDirective,
    TransformFormGroupDirective,
    EditDialogComponent,
    CustomTooltipComponent,
    CopyDataRendererComponent,
    FilterToolbarComponent,
    HomeRootComponent,
  ],
  exports: [
    SelectLanguageComponent,
    ApproveDialogComponent,
    DeleteDialogComponent,
    TranslateDialogComponent,
    DataTableComponent,
    WikiComponent,
    CustomFilterComponent,
    FormatCellPipe,
    FileUploaderComponent,
    FileLookPopupComponent,
    DynamicCellFormComponent,
    TransformDirective,
    TransformFormGroupDirective,
    EditDialogComponent,
    TextboxCellComponent,
    TextareaCellComponent,
    CheckboxCellComponent,
    CheckboxGroupCellComponent,
    CheckboxListCellComponent,
    SelectlistCellComponent,
    SelectlistSearchCellComponent,
    SelectlistControlCellComponent,
    DatepickCellComponent,
    ColorpickerCellComponent,
    DndCellComponent,
    TranslatedCellComponent,
    FileCellComponent,
    TimeCellComponent,
    DynamicListComponent,
    CustomTooltipComponent,
    CopyDataRendererComponent,
    FilterToolbarComponent,
    HomeRootComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
  ],
  providers: [
    TitleService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
    MenuService,
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_DATE_FNS_FORMATS
    },
  ],
})
export class SharedModule {}
